import get from 'platform/utilities/data/get';
import {
  addressSchema,
  addressUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  claimantFields,
  mailingAddressText,
  POSTAL_CODE_ERROR_MESSAGES,
} from '../definitions/constants';

const claimantAddressUI = addressUI({
  labels: {
    street: mailingAddressText.streetLabel,
    street2: mailingAddressText.apartmentUnitLabel,
    city: mailingAddressText.cityLabel,
    postalCode: mailingAddressText.zipCodeLabel,
  },
  omit: ['street3'],
  required: { state: () => true },
});

claimantAddressUI.street = {
  ...claimantAddressUI.street,
  'ui:errorMessages': {
    ...claimantAddressUI.street?.['ui:errorMessages'],
    required: mailingAddressText.streetRequiredError,
  },
};

claimantAddressUI.country = {
  ...claimantAddressUI.country,
  'ui:errorMessages': {
    ...claimantAddressUI.country?.['ui:errorMessages'],
    required: mailingAddressText.countryRequiredError,
  },
};

claimantAddressUI.city = {
  ...claimantAddressUI.city,
  'ui:errorMessages': {
    ...claimantAddressUI.city?.['ui:errorMessages'],
    required: mailingAddressText.cityRequiredError,
  },
};

claimantAddressUI.state = {
  ...claimantAddressUI.state,
  'ui:title': mailingAddressText.stateLabel,
  'ui:errorMessages': {
    ...claimantAddressUI.state?.['ui:errorMessages'],
    required: mailingAddressText.stateRequiredError,
    enum: mailingAddressText.stateRequiredError,
  },
};

const originalPostalReplaceSchema =
  claimantAddressUI.postalCode?.['ui:options']?.replaceSchema;
if (originalPostalReplaceSchema) {
  claimantAddressUI.postalCode['ui:options'].replaceSchema = (
    formData,
    schema,
    uiSchema,
    index,
    path,
  ) => {
    const result = originalPostalReplaceSchema(
      formData,
      schema,
      uiSchema,
      index,
      path,
    );
    const addressPath = path?.length ? path.slice(0, -1) : [];
    const addressData = get(addressPath, formData) ?? {};
    const { country } = addressData;
    let messages = POSTAL_CODE_ERROR_MESSAGES.OTHER;
    if (country === 'USA') {
      messages = POSTAL_CODE_ERROR_MESSAGES.USA;
    } else if (['CAN', 'MEX'].includes(country)) {
      messages = POSTAL_CODE_ERROR_MESSAGES[country];
    } else if (!country) {
      messages = POSTAL_CODE_ERROR_MESSAGES.NONE;
    }
    // eslint-disable-next-line no-param-reassign -- platform replaceSchema mutates uiSchema
    uiSchema['ui:errorMessages'] = messages;
    return result;
  };
}

export default {
  uiSchema: {
    'ui:options': { preserveHiddenData: true , forceDivWrapper: true},
    ...titleUI(
      mailingAddressText.pageTitle,
      mailingAddressText.pageDescription,
    ),
    [claimantFields.parentObject]: {
      [claimantFields.address]: claimantAddressUI,
    },
  },
  schema: {
    type: 'object',
    properties: {
      [claimantFields.parentObject]: {
        type: 'object',
        properties: {
          [claimantFields.address]: addressSchema({ omit: ['street3'] }),
        },
        required: [claimantFields.address],
      },
    },
  },
};
